function TimerDisplay({ time, style }) {
  // Convert time from milliseconds to seconds
  const timeInSeconds = Math.floor(time / 1000);

  return (
    <div className={`${style}`}>
      {timeInSeconds >= 0
        ? `${Math.floor(timeInSeconds / 3600)
            .toString()
            .padStart(2, '0')}:${Math.floor((timeInSeconds % 3600) / 60)
            .toString()
            .padStart(2, '0')}:${(timeInSeconds % 60)
            .toString()
            .padStart(2, '0')}`
        : '00:00:00'}
    </div>
  );
}

export default TimerDisplay;
